<template>
  <div class="page-width botPage">
    <mbHeader :title="$t('orderSummary')" :left="true" :lang="true"></mbHeader>
    <div class='confirmation'>
      <div class="no-orders" v-if="!orderLoading && !orderSuccessful">
        <h2>{{ $t('no_orders_processed') }}</h2>
      </div>
      <div v-if="orderLoading && !orderSuccessful" class="pending-confirmation">
        <h2>{{ $t('pendingConfirmation') }}</h2>
        <div class="svg">
          <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px"
               width="100px" height="100px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
               xml:space="preserve">
              <path fill="#E9C34B"
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                <animateTransform attributeType="xml"
                                  attributeName="transform"
                                  type="rotate"
                                  from="0 25 25"
                                  to="360 25 25"
                                  dur="1s"
                                  repeatCount="indefinite"
                />
              </path>
            </svg>
        </div>
        <a class="waiting">{{ $t('waitProcessing') }}</a>
      </div>
      <div v-else-if="!orderLoading && orderSuccessful" :style="{ marginTop: '30px' }">
        <div class="con-header">
          <div class="order-icon">
            <font-awesome-icon icon="check" :style="{ color: 'white', fontSize: '20px',   }"/>
          </div>
          <p class="order-confirm">{{ $t('we_received_order') }}</p>
          <p class="con-title">{{ $t('order_no') }} {{ this.orderTest.SONum }}</p>
          <p class="email-copy">{{ $t('a_copy_receipt') }} {{ userDetails.email }}</p>
        </div>
        <div class="delivery-details" v-if="false">
          <p class="con-title bottom-margin">{{ $t('delivery_details') }}</p>
          <div class="order-content">
            <div class="details-box">
              <p class="con-subheader">{{ $t('delivery_for') }}</p>
              <p class="con-text" v-if="this.orderTest.ShippingMethod === 'Delivery'">
                {{ this.shippingAddress.FirstName }} {{ this.shippingAddress.LastName }}</p>
              <p class="con-text" v-else-if="this.orderTest.ShippingMethod === 'Pickup'">
                {{ this.billingAddress.FirstName }} {{ this.billingAddress.LastName }}</p>
            </div>
            <div class="details-box">
              <p class="con-subheader">{{ $t('delivery_method') }}</p>
              <p class="con-text">{{ this.orderTest.ShippingMethod }}</p>
              <p class="con-text" v-if="this.orderTest.ShippingMethod === 'Delivery'">Estimated Delivery:
                {{ this.orderTest.TimeSlot }}</p>
              <p class="con-text" v-if="this.orderTest.ShippingMethod === 'Pickup'">
                Store Location: {{ this.warehouse.address }}
              </p>
            </div>
            <div class="details-box">
              <p class="con-subheader">{{ $t('address') }}</p>
              <p class="con-text">{{ this.shippingAddress.Street }} {{ this.shippingAddress.City }},
                {{ this.shippingAddress.Zip }}
              </p>
              <p class="con-text">{{ this.shippingAddress.Telephone }}</p>
            </div>
            <div class="details-box" v-if="!this.savedCardAddress">
              <p class="con-subheader">{{ $t('billing_address') }}</p>
              <p class="con-text">{{ this.billingAddress.Street }} {{ this.billingAddress.City }},
                {{ this.billingAddress.Zip }}
              </p>
            </div>
            <div class="details-box" v-if="this.savedCardAddress">
              <p class="con-subheader">{{ $t('billing_address') }}</p>
              <p class="con-text">{{ this.savedCardAddress.address }} {{ this.savedCardAddress.city }}
                {{ this.savedCardAddress.state }}, {{ this.savedCardAddress.zip }}
              </p>
            </div>
          </div>
        </div>
        <div class="order-summary">
          <p class="con-title bottom-margin">{{ $t('order_summary') }}</p>
          <div class="products-sum">
            <ul>
              <li class="products-bought" v-for="(item, index) in this.orderTest.Sales_Order_Line" key="index">
                <p v-if='$i18n.locale=="en"' class="con-text sixty">{{ item.ProductName }}</p>
                <p v-if='$i18n.locale=="ch"' class="con-text sixty">{{ item.ProductDescription }}</p>
                <div class="confirm-quant twenty">
                  <p class="bought">{{ item.Quantity }}</p>
                </div>
                <p class="con-title twenty">${{ item.TotalPrice }}</p>
              </li>
            </ul>
          </div>
          <!-- <div class="order-coup" v-if="this.orderTest.Savings >= 0">
            <p class="con-title bottom-margin">Coupon</p>
            <p class="con-text">Savings: ${{(this.orderTest.Savings).toFixed(2)}}</p>
          </div> -->
          <div class="price-sum">
            <div class="price-holder bottom-margin-small">
              <p class="con-text">{{ $t('subtotal_afm') }}</p>
              <p class="con-text">${{ this.orderTest.TotalPrice }}</p>
            </div>
            <div class="price-holder bottom-margin-small">
              <p class="con-text">{{ $t('discount_afm') }}</p>
              <p class="con-text">-${{ this.orderTest && (this.orderTest.Savings).toFixed(2) }}</p>
            </div>
            <div class="price-holder bottom-margin-small" v-if="this.orderTest.ShippingMethod === 'Delivery'">
              <p class="con-text">{{ $t('delivery_fee') }}</p>
              <p class="con-text">${{ this.orderTest && (this.orderTest.Delivery).toFixed(2) }}</p>
            </div>
            <div class="price-holder bottom-margin-small">
              <p class="con-text">{{ $t('tax_afm') }}</p>
              <p class="con-text">${{ this.orderTest && (this.orderTest.TaxAmount).toFixed(2) }}</p>
            </div>
            <div class="price-holder top-margin">
              <p class="con-title">{{ $t('total_afm') }}</p>
              <p class="con-title">${{ this.orderTest && (this.orderTest.GrandTotal).toFixed(2) }}</p>
            </div>
          </div>
        </div>
        <p @click="goHome" class="back-home">{{ $t('back_home')}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapMutations, mapActions} from "vuex";
import mbHeader from "../components/mobile/mbHeader";

export default {
  name: 'confirmation',
  components: {mbHeader},
  data() {
    return {
      interval: null,
      orderTest: {},
      billingAddress: {
        Street: '',
        City: '',
        Zip: ''
      },
      shippingAddress: {
        Street: '',
        City: '',
        Zip: ''
      },
      warehouses: [
        {name: 'Bellevue', address: '14515 NE 20th St, Bellevue, WA 98007', phone: '(425) 643-8558', value: '98007'},
        {name: 'Beaverton', address: '3849 SW 117TH Ave Beaverton, OR 97005', phone: '503-520-1880', value: '97005'},
        {name: 'Seattle', address: '13200 Aurora Ave N Seattle, WA 98133', phone: '206-367-1229', value: '98133'},
      ],
      warehouse: '',
    }
  },
  created() {
    this.searchForId();
  },
  mounted() {
    this.$store.dispatch('orders/fetchOrderByTimeFrameReturn', 1)
      .then(res => {
        this.findOrders(res.data[res.data.length - 1])
      })
  },
  beforeDestroy() {
    this.stopSearchForId();
  },
  methods: {
    ...mapActions('checkout', ['fetchAchProfiles']),
    ...mapActions('orders', ['fetchSODetails', 'fetchOrderByTimeFrameReturn']),
    ...mapMutations('checkout', ['clearOrderData', 'resetSavedCard']),
    checkForConfirmation() {
      this.$store.dispatch('checkout/confirmSalesOrder', this.salesOrderId)
    },
    searchForId() {
      var that = this;
      if (this.orderLoading && !this.orderSuccessful) {
        this.interval = setInterval(function () {
          that.checkForConfirmation();
        }, 4000);
      }
    },
    goHome() {
      this.$router.push('/home')
    },
    stopSearchForId() {
      clearInterval(this.interval);
    },
    // findBillingAddress(billingId) {
    //   this.customerDetails && this.customerDetails.map(address => {
    //     if (address.CustomerDetail_id === billingId) {
    //       this.billingAddress = address;
    //       return;
    //     }
    //   });
    // },
    findOrders(order) {
      this.fetchSODetails(order.SalesOrder_id)
        .then((res) => {
          this.orderTest = res.data;
          this.shippingAddress = res.data.Shipping_Address;
          this.billingAddress = res.data.Billing_Address;
          // if (!this.savedCardAddress) {
          //   this.findBillingAddress(res.data.Billing_CustomerDetail_id)
          // }
          this.findWarehouse();
        })
    },
    findWarehouse() {
      this.warehouse = this.warehouses.find(item => item.name === this.orderTest.Shipping_Address.City)
    }
  },
  watch: {
    $route(to, from) {
      if (from.name === 'purchase') {
        this.$store.dispatch('orders/fetchOrderByTimeFrameReturn', 1)
          .then(res => {
            this.findOrders(res.data[res.data.length - 1])
          })
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.stopSearchForId();
    this.clearOrderData();
    this.resetSavedCard();
    next();
  },
  computed: mapState({
    orderSuccessful: state => state.checkout.orderSuccessful,
    orderLoading: state => state.checkout.orderLoading,
    salesOrderId: state => state.checkout.salesOrderId,
    orders: state => state.orders.orderTimeFrame,
    orderDetails: state => state.orders.orderDetails,
    userDetails: state => state.auth.userDetails,
    savedCards: state => state.checkout.savedCards,
    customerDetails: state => state.addresses.customerDetails,
    savedCardAddress: state => state.checkout.savedCardAddress
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/confirmation.less";
</style>



// WEBPACK FOOTER //
// src/view/confirmation.vue